import React from 'react';
import { Wrapper } from './nex-logo-title.styles';

const NexLogoTitle = () => {
    return <Wrapper>Nex Cash Admin Dashboard</Wrapper>;
};

export default NexLogoTitle;
